__turbopack_context__.v({
  "container": "index-module__dHeE9a__container",
  "cookieButton": "index-module__dHeE9a__cookieButton",
  "leftSide": "index-module__dHeE9a__leftSide",
  "rightSection": "index-module__dHeE9a__rightSection",
  "root": "index-module__dHeE9a__root",
});
